import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeDeviation'
})
export class TimeDeviationPipe implements PipeTransform {

  transform(inputSeconds: number | null): string {
    if (inputSeconds == null)
      return null;

    const minutes = Math.floor(Math.abs(inputSeconds) / 60);
    const seconds = Math.abs(inputSeconds) - minutes * 60;
    let minutesText = '';
    if (minutes > 0) minutesText += `${minutes} min. `;
    return `${inputSeconds < 0 ? '-' : ''}${minutesText}${seconds} s`;
  }

}
